import React from "react";
import { Navigate } from "react-router-dom";

const AdminRoute = ({ children }) => {
  const isAdminVerified = sessionStorage.getItem("adminVerified");

  if (!isAdminVerified) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default AdminRoute;
